import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '旅行探险', path: '/category/travel' },
  { name: '美食烹饪', path: '/category/food' },
  { name: '数码科技', path: '/category/tech' },
  { name: '读书思考', path: '/category/reading' },
  { name: '运动健身', path: '/category/fitness' },
  { name: '艺术创作', path: '/category/art' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 group"
          aria-label="蘑菇社区首页"
        >
          <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-leaf-line text-lg text-background-50"></i>
          </div>
          <span
            className={`text-lg font-heading font-semibold whitespace-nowrap transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}
          >
            蘑菇社区
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === link.path
                  ? scrolled
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-white/20 text-white'
                  : scrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {link.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className={`text-sm font-medium whitespace-nowrap transition-colors ${
              scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
            }`}
          >
            登录
          </Link>
          <Link
            to="/about"
            className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg whitespace-nowrap transition-colors cursor-pointer"
          >
            免费加入
          </Link>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            scrolled ? 'text-foreground-900' : 'text-white'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="打开菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === link.path
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <div className="flex gap-3 pt-2">
            <Link
              to="/about"
              className="flex-1 text-center px-4 py-2.5 border border-background-300 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              登录
            </Link>
            <Link
              to="/about"
              className="flex-1 text-center px-4 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors"
            >
              免费加入
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}